import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { filter, map, take } from 'rxjs';
import { ContextService } from '../context.service';
import { Role } from './models/role';

export const hasRoleGuard = (...allowedRoles: Role[]): CanActivateFn => {
  return () => {
    const contextService = inject(ContextService);
    const router = inject(Router);

    return contextService.loaded$.pipe(
      // Wait until the context has loaded from /me before checking roles. Gate
      // on load (user present), NOT org presence — an org-less super-admin has
      // valid roles but no organization, and gating on org would hang the
      // admin routes forever.
      filter((loaded) => loaded),
      take(1),
      map(() => {
        if (contextService.hasAnyRole(...allowedRoles)) {
          return true;
        }

        console.warn(`Access denied: requires one of [${allowedRoles.join(', ')}]`);
        return router.createUrlTree(['/not-found']);
      })
    );
  };
};
